var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-content" },
    [
      _c("div", { staticClass: "logo" }),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "close-button", on: { click: _vm.closePage } },
        [_vm._v("\n        Close\n      ")]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "table-content" }, [
      _c("div", { staticClass: "content-title" }, [
        _vm._v(
          "\n        SITC DANGEROUS GOODS FROHIBITEO & RESTRICTED LIST\n      "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { height: "30px" } }),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "5px" } }, [
        _c(
          "table",
          {
            staticStyle: { "border-collapse": "collapse" },
            attrs: {
              align: "center",
              width: "100%",
              border: "1px solid rgb(204,204,204)",
              cellpadding: ".",
            },
          },
          [
            _c("tbody", [
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: {
                      width: "25%",
                      "background-color": "rgba(209,232,255,1)",
                      "text-align": "center",
                    },
                  },
                  [_vm._v("\n              CLASS\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: {
                      "background-color": "rgba(221,221,221,1)",
                      "text-align": "center",
                    },
                    attrs: { colspan: "9" },
                  },
                  [_vm._v("\n              UN NO.\n            ")]
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [_vm._v("\n                1\n              ")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                Explosive\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                爆炸品\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("td", { attrs: { colspan: "9" } }, [
                  _c("span", { staticStyle: { color: "red" } }, [
                    _vm._v("\n                ALL PROHIBITED\n              "),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "#06C" } }, [
                    _vm._v(
                      "\n                EXCEPT 1.4S &1.6 IN ACCORDANCE WITH LOCAL/VSL RULES\n              "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                2.1\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Flammable gases\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                易燃气体\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1001")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1075")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1961")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1964")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1965")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1966")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1971")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1972")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3138")]
                ),
              ]),
              _vm._v(" "),
              _c("tr", { staticStyle: { color: "red" } }, [
                _c("td", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("3161"),
                ]),
                _vm._v(" "),
                _c("td", { attrs: { colspan: "7" } }, [
                  _vm._v(
                    "\n              (ABOVE LIST ONLY TANK CNTR ACCEPTABLE)\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", { staticStyle: { color: "red" } }, [
                _c("td", { staticStyle: { "text-align": "center" } }, [
                  _vm._v("2203"),
                ]),
                _vm._v(" "),
                _c("td", { attrs: { colspan: "3" } }, [
                  _vm._v("\n              (ALWAYS PROHIBITED)\n            "),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                2.2\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Non_flammable, no-toxic gases\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                不可燃，无毒性气体\n              "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                2.3\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                Toxic gases\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                毒性气体\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red" }, attrs: { colspan: "3" } },
                  [_vm._v("\n              ALL PROHIBITED\n            ")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "6" },
                  },
                  [
                    _c("div", [_vm._v("\n                3\n              ")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Flammable Liquids\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                易燃液体\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "#06C" }, attrs: { colspan: "9" } },
                  [
                    _vm._v(
                      "\n              ALL Flammable liquid substances flash point below -18 C should be restricted\n            "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1113")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2398")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1127")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1131")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1146")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1154")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1159")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1160")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("1164")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1190")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1194")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1234")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1261")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1265")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1275")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1277")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("1298")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("1865")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2461")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2402")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2246")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2612")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2347")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c("td", { attrs: { colspan: "6" } }, [
                  _c("div", { staticStyle: { color: "red" } }, [
                    _vm._v(
                      "\n                (ABOVE LIST ONLY TANK CNTR ACCEPTABLE)\n              "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                4.1\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Flammable Solids\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                易燃固体\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticStyle: { color: "red", "text-align": "center" },
                    attrs: { colspan: "2" },
                  },
                  [_vm._v("\n              (3221-3241)\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3251")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "4" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                4.2\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Spontaneously Combustible\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                自燃性物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1380")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1381")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1383")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1854")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1855")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2008")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2447")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2545")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2546")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("2845")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2846")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2870")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("2881")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3088")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3190")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3194")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3200")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3254")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("3313")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3391")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3392")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3393")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3394")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                4.3\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Dangerous when wet\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                遇水危险物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1295")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1418")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3129")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3130")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3131")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3132")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3134")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3135")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3148")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("3208")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3209")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                5.1\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Oxidizing Substances\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                氧化物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1512")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1748")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2208")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("2880")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3210")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3211")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3212")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                5.2\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Organic Peroxides\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                有机过氧化物\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3101")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3102")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3111")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3112")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3113")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3114")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3115")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3116")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3117")]
                ),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v("3118")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3119")]),
                  _vm._v(" "),
                  _c("td", [_vm._v("3120")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                6.1\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Toxic Substances\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                有毒物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1163")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1259")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("1614")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3124")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("3315")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [
                      _vm._v("\n                6.2\n              "),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Infectious Substances\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                感染性物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red" }, attrs: { colspan: "3" } },
                  [_vm._v("\n              ALL PROHIBITED\n            ")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [_vm._v("\n                7\n              ")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Radioactive Material\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                放射性物质\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red" }, attrs: { colspan: "3" } },
                  [_vm._v("\n              ALL PROHIBITED\n            ")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [_vm._v("\n                8\n              ")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Corrosive Substances\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v("\n                腐蚀品\n              "),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("\n              1826\n            ")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c("tr", [
                _c(
                  "td",
                  {
                    staticStyle: { width: "25%", "text-align": "center" },
                    attrs: { rowspan: "3" },
                  },
                  [
                    _c("div", [_vm._v("\n                9\n              ")]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                Miscellaneous D.G.Substances\n              "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                其他类危险物质\n              "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("\n              3257\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { color: "red", "text-align": "center" } },
                  [_vm._v("\n              3258\n            ")]
                ),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
                _vm._v(" "),
                _c("td", [_vm._v(" ")]),
              ]),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "tr",
                { staticStyle: { color: "red", "text-align": "center" } },
                [
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("td", [_vm._v(" ")]),
                ]
              ),
            ]),
          ]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }